import { useNavigate } from 'react-router-dom';

import { Stack } from '@ekhodealer/ekho-common/rev';

import { TablePageLayout } from '@common/components/TablePageLayout';
import { useCurrentServicesProviderId } from '@common/hooks/useCurrentServicesProviderId';
import ReportsOrdersSummary from '@features/reports/components/reports_orders/ReportsOrdersSummary';
import ReportsOrdersTable from '@features/reports/components/reports_orders/ReportsOrdersTable';
import ReportsOrdersToolbar from '@features/reports/components/reports_orders/ReportsOrdersToolbar';
import { paths } from '@config/paths';

export default function ReportsOrdersPage() {
	const navigate = useNavigate();
	const servicesProviderId = useCurrentServicesProviderId();

	const handleReportsClick = () => {
		if (servicesProviderId) {
			navigate(paths.reports.getHref(servicesProviderId));
		}
	};

	return (
		<TablePageLayout
			breadcrumb={{
				items: [
					{
						id: 'reports',
						label: 'Reports',
						onActivate: handleReportsClick,
					},
					{
						id: 'orders',
						label: 'Orders',
					},
				],
				currentId: 'orders',
			}}
			aboveTableContent={
				<Stack itemsSpacing='16'>
					<ReportsOrdersToolbar />
					<ReportsOrdersSummary />
				</Stack>
			}
			tableContent={<ReportsOrdersTable />}
		/>
	);
}
